/* eslint-disable typescript-sort-keys/string-enum */
var ColorNeutral;
(function (ColorNeutral) {
    ColorNeutral["BLACK"] = "black";
    ColorNeutral["WHITE"] = "white";
})(ColorNeutral || (ColorNeutral = {}));
var ColorGlobal;
(function (ColorGlobal) {
    ColorGlobal["GRAY"] = "gray";
    ColorGlobal["GROUP_BLUE"] = "group-blue";
    ColorGlobal["BLUE"] = "blue";
    ColorGlobal["AQUA"] = "aqua";
    ColorGlobal["GREEN"] = "green";
    ColorGlobal["ORANGE"] = "orange";
    ColorGlobal["PINK"] = "pink";
    ColorGlobal["PURPLE"] = "purple";
})(ColorGlobal || (ColorGlobal = {}));
var ColorSafety;
(function (ColorSafety) {
    ColorSafety["BLUE"] = "blue";
    ColorSafety["GREEN"] = "green";
    ColorSafety["YELLOW"] = "yellow";
    ColorSafety["ORANGE"] = "orange";
    ColorSafety["RED"] = "red";
    ColorSafety["HAZARD"] = "hazard";
    ColorSafety["VIGILANCE"] = "vigilance";
})(ColorSafety || (ColorSafety = {}));
var ColorSignal;
(function (ColorSignal) {
    ColorSignal["INDIGO"] = "indigo";
    ColorSignal["BLUE"] = "blue";
    ColorSignal["CYAN"] = "cyan";
    ColorSignal["GREEN"] = "green";
    ColorSignal["LIME"] = "lime";
    ColorSignal["YELLOW"] = "yellow";
    ColorSignal["ORANGE"] = "orange";
    ColorSignal["RED"] = "red";
    ColorSignal["PINK"] = "pink";
    ColorSignal["PURPLE"] = "purple";
    ColorSignal["GRAY"] = "gray";
})(ColorSignal || (ColorSignal = {}));
var SignalShade;
(function (SignalShade) {
    SignalShade["S30"] = "30";
    SignalShade["S40"] = "40";
    SignalShade["S45"] = "45";
    SignalShade["S50"] = "50";
    SignalShade["S60"] = "60";
})(SignalShade || (SignalShade = {}));
var ColorShade;
(function (ColorShade) {
    ColorShade["S05"] = "5";
    ColorShade["S10"] = "10";
    ColorShade["S15"] = "15";
    ColorShade["S20"] = "20";
    ColorShade["S25"] = "25";
    ColorShade["S30"] = "30";
    ColorShade["S35"] = "35";
    ColorShade["S40"] = "40";
    ColorShade["S45"] = "45";
    ColorShade["S50"] = "50";
    ColorShade["S55"] = "55";
    ColorShade["S60"] = "60";
    ColorShade["S65"] = "65";
    ColorShade["S70"] = "70";
    ColorShade["S75"] = "75";
    ColorShade["S80"] = "80";
    ColorShade["S85"] = "85";
    ColorShade["S90"] = "90";
})(ColorShade || (ColorShade = {}));
export { ColorNeutral, ColorGlobal, ColorSafety, ColorShade, ColorSignal, SignalShade, };
//# sourceMappingURL=color.js.map